import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { path, pipe, toPairs, filter } from 'ramda'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import bindAllActions from '../../common/bindAllActions'
import SettingRadio from '../user/SettingRadio'
import SettingSelect from '../user/SettingSelect'
import PhoneProcess from '../user/PhoneProcess'
import AlertCrud from './Crud'
import Instances from './Instances'
import AlertSets from './AlertSets'
import QuestionMark from '../../components/QuestionMark'
import AmbRadio from '../../components/AmbRadio'
import AwnSwitch from '../common/AwnSwitch'
import { isUserPhoneConfirmed, pluckClean, getDisplayKeys, getUserSetting, isCordova, isRole, isIos, isApp, hasHst } from '../../common/ambient'
import { getThemeObj } from '../../common/skinner'
import { CopyLink, Loader } from '../../components'
import { isPlus } from '../payment'
import { isDev } from '../../common/ambient/utils'
import { ALERT_FREQS, alertSetsAvail } from '.'
import AlertList from './AlertList'

const ALERT_TABS = {
  timeline: 'Timeline',
  alerts: 'My Alerts',
  group: 'Team Alerts',
}
class DefaultPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    alertActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    alert: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired
  };

  state = {
    multiSmsChecked: false,
    alertRecipientEmailInfo: {},
    tab: 'alerts',
  }

  componentDidMount () {
    this._checkMultiSmsLink()
    window.scrollTo(0, 0)
  }

  componentDidUpdate (prevProps) {
    this._checkMultiSmsLink()
    // Scroll to top when switching tabs
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.scrollTo(0, 0)
    }
  }

  _checkMultiSmsLink () {
    const { user } = this.props
    const { multiSmsChecked } = this.state
    const { userChecked } = user
    if (userChecked && this._hasMultiSms() && !multiSmsChecked) {
      this.setState({ multiSmsChecked: true })
      this._fetchMultiSmsLink()
    }
  }

  _fetchMultiSmsLink () {
    this.setState({ multiSmsLinkUaFetched: false })
    this.props.socialActions.fetchUserActions({
      userId: this.props.user.info._id,
      type: 'multi-sms-link'
    })
      .then(res => {
        this.setState({
          multiSmsLinkUa: res.data[0],
          multiSmsLinkUaFetched: true
        })
      })
  }

  _socialPrefs () {
    const { user } = this.props
    const alertSettings = getUserSetting('alerts')(user) || {}
    const settingKey = 'social'
    const socialPrefs = [
      ['Email & Website', 'all'],
      [`${isCordova() ? 'App' : 'Website'} Only`, 'app']
    ]
    const radios = socialPrefs.map((arr) => {
      const label = arr[0]
      const key = arr[1]
      return (
        <SettingRadio
          defaultValue='all'
          key={key}
          setting='alerts'
          settingKey={settingKey}
          value={key}
          label={label}
        />
      )
    })
    return (
      <div className='block social-comm'>
          <h3>Social Feed Notifications</h3>
          <div className='prefs'>
            {radios}
          </div>
          {!alertSettings[settingKey] || alertSettings[settingKey] === 'all' ? <div className='message'>{this._emailMessage()}</div> : ''}
          </div>
    )
  }

  _emailMessage () {
    const { user, userActions } = this.props
    let message
    if (!path(['info', 'isVerified'], user)) {
      const link = user.sendConfirmationSucceeded
        ? <b>Confirmation Sent!</b>
        : <a
            className='btn btn-primary'
            onClick={() => {
              userActions.sendConfirmation({ user: user.info._id, confirmKey: true })
          }}
          >Resend</a>
      message = (
        <p className="warning">
          <span>Alerts will not be sent until your email address ({user.info.email}) is confirmed. </span>
          {link}
        </p>
      )} else {
      message = <p>We'll send emails to {user.info.email}.</p>
    }
    return message
  }

  _hasMultiSms () {
    return isRole('multi-sms', this.props.user) || (this.props.device.devices && this.props.device.devices.filter(hasHst).length > 0)
  }

  render () {
    const { socialActions, userActions, user, match } = this.props
    const { multiSmsLinkUa, multiSmsLinkUaFetched, alertRecipientEmailInfo, appAlertExplain } = this.state
    const { tab = 'alerts' } = match.params || {}
    const { fetchUserPending } = user
    const alertSettings = getUserSetting('alerts')(user) || {}
    const alertChannel = [
      [<span>No&nbsp;notifications</span>, 'none'],
      ['Email', 'email'],
      ['App', 'app'],
      ['SMS', 'sms']
    ]
    let radios = alertChannel.map((arr) => {
      const label = arr[0]
      const key = arr[1]
      return (
        <SettingRadio
          key={key}
          setting='alerts'
          settingKey='type'
          value={key}
          label={label}
        />
      )
    })
    let alertTypes = []
    if (alertSettings.type) {
      alertTypes = typeof alertSettings.type === 'string' ? [alertSettings.type] : alertSettings.type
    }
    const hasAlertType = type => alertTypes.includes(type)

    const hasAppDevice = path(['info', 'appDevices'], user)

    radios = alertChannel.map((arr) => {
      const label = arr[0]
      const key = arr[1]
      return (
        <AmbRadio
          key={key}
          label={label}
          className={key === 'sms' && 'plus'}
          selected={key === 'none' ? alertTypes.length === 0 : hasAlertType(key)}
          onClick={() => {
            if (key === 'sms' && !isPlus(user)) {
              userActions.doModal({
                type: 'plus-subscription',
                data: {
                  message: 'SMS alerts are only available to AWN+ subscribers.'
                }
              })
              // dont let them add it
              if (!hasAlertType(key)) {
                return
              }
            }
            if (key === 'app' && !hasAppDevice) {
              this.setState({ appAlertExplain: true })
              return
            }
            let newAlertSettings
            if (key === 'none') {
              newAlertSettings = Object.assign({}, alertSettings, { type: [] })
            } else {
              newAlertSettings = Object.assign({}, alertSettings, { type: hasAlertType(key) ? alertTypes.filter((type) => type !== key) : alertTypes.concat(key) })
            }
            userActions.updateSetting('alerts', newAlertSettings)
          }}
        />
      )
    })
    const messages = []
    if (hasAlertType('email')) {
      messages.push(<div key='email'>{this._emailMessage()}</div>)
    }
    if (hasAlertType('sms')) {
      const yesPhone = (
        <>
          <p>
            We'll send texts to {user.info.phone}
            <span className='pull-right'>
              SMS messages remaining: {path(['info', 'smsBankUpdated'], user) ? (user.info.smsBank || 0) : 10}
              <QuestionMark link="https://ambientweather.com/faqs/question/view/id/12621/" />
            </span>
            <small>
              <a className='glyphicon glyphicon-trash' onClick={() => {
                if (window.confirm('Are you sure?')) {
                  userActions.patch(user.info._id, { phone: '', phoneConfirmKey: false })
                }
              }}
              />
            </small>
          </p>
          {this._hasMultiSms() && <p className='warning'>For SMS WBGT Guideline alerts make sure to add your phone number below.</p>}
        </>
      )
      messages.push(<div key='sms'>{isUserPhoneConfirmed(user) ? yesPhone : <PhoneProcess />}</div>)
    }
    if (hasAlertType('app')) {
      const devicesWithPermission = pipe(
        path(['info', 'appDevices']),
        toPairs,
        filter(([key, obj]) => obj.notificationsEnabled)
      )(user)
      if (!fetchUserPending && isApp() && devicesWithPermission.length < 1) {
        messages.push(
          <p key='app'>
            You have no devices with permission to receive push notifications.
            {isApp() && <span> Please go to Settings &gt; Notifcations &gt; Ambient Weather to enable push notifications</span>}
          </p>
        )
      }
    }
    let freq = ''
    if (alertTypes.length > 0) {
      freq = (
        <SettingSelect
          setting='alerts'
          settingKey='freq'
          values={ALERT_FREQS}
          label='Notification Time Window'
        />
      )
    }
    let multiSms = null
    if (this._hasMultiSms()) {
      // Calculate how many SMS recipients we have and how many more can be added
      const MAX_SMS_RECIPIENTS = 15
      const currentSmsRecipients = (alertSettings.smsRecipients || []).filter(r => r.phone && !r.disabled).length
      const remainingSlots = MAX_SMS_RECIPIENTS - currentSmsRecipients
      
      let smsBody = <Loader />
      let recipients = null
      if (multiSmsLinkUaFetched) {
        if (multiSmsLinkUa) {
          const shareLink = `https://${window.location.host}/common/ua/${multiSmsLinkUa._id}?code=${multiSmsLinkUa.data.code}`
          smsBody = (
            <div className='alert-recipient-forms'>
              <h4>SMS Invite Link</h4>
              {remainingSlots > 0 ? (
                <>
                  <p>Use this link to invite an <b>SMS</b> alert recipient:</p>
                  <p>
                    <input type='text' className='sms-share-input form-control' value={shareLink} onFocus={e => e.currentTarget.select()} />
                    &nbsp;<CopyLink text={shareLink} className='btn btn-primary' />
                    &nbsp;&nbsp;
                    <a
                      onClick={() => {
                        if (window.confirm('The current share link will no longer work. Continue?')) {
                          socialActions.patchUserAction(multiSmsLinkUa._id, { data: { code: Math.floor(Math.random() * 1000000) } })
                            .then(res => {
                              console.log('patched', res)
                              this.setState({
                                multiSmsLinkUa: null,
                                multiSmsLinkUaFetched: false,
                                multiSmsChecked: false
                              })
                            })
                        }
                      }}
                      className='small'
                    >revoke</a>
                  </p>
                  <p className="remaining-slots">You can add up to {remainingSlots} more SMS alert recipient{remainingSlots !== 1 ? 's' : ''}</p>
                </>
              ) : (
                <p className="remaining-slots max-reached">You have reached the maximum number of SMS alert recipients. Disable or delete one to add more.</p>
              )}
              <div className='email'>
                <h4>Email Recipients</h4>
                <p>To add an <b>email</b> based recipient add their email address below:</p>
                <div>
                  <div>
                    <input value={alertRecipientEmailInfo.name} onChange={evt => this.setState({ alertRecipientEmailInfo: Object.assign({}, alertRecipientEmailInfo, { name: evt.target.value }) })} type='text' className='form-control' placeholder='Name' />
                  </div>
                  <div>
                    <input value={alertRecipientEmailInfo.email} onChange={evt => this.setState({ alertRecipientEmailInfo: Object.assign({}, alertRecipientEmailInfo, { email: evt.target.value }) })} type='email' className='form-control' placeholder="Email" />
                  </div>
                  <button className='btn btn-primary' onClick={() => {
                    const settings = Object.assign({}, alertSettings)
                    settings.smsRecipients = settings.smsRecipients || []
                    settings.smsRecipients.push(alertRecipientEmailInfo)
                    userActions.updateSetting('alerts', settings)
                    this.setState({ alertRecipientEmailInfo: { name: '', email: '' } })
                  }} disabled={!alertRecipientEmailInfo.name || !alertRecipientEmailInfo.email}>Add Email Recipient</button>
                </div>
              </div>
            </div>
          )
        } else {
          smsBody = (
            <div className='message'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  socialActions.addUserAction({
                    userId: user.info._id,
                    type: 'multi-sms-link',
                    data: {
                      code: Math.floor(Math.random() * 1000000)
                    }
                  })
                    .then(this._fetchMultiSmsLink.bind(this))
                }}
              >
                Invite WBGT Alert Subscribers
              </button>
            </div>
          )
        }
      }
      if (alertSettings.smsRecipients && alertSettings.smsRecipients.length) {
        recipients = (
          <div className='sms-recipients'>
            <div className='recipient-header'>
              <div className='recipient-col'>Name</div>
              <div className='recipient-col'>Type</div>
              <div className='recipient-col'>Contact</div>
              <div className='recipient-col'>Enabled?</div>
              <div className='recipient-col'>Delete</div>
            </div>
            <div className='recipient-rows'>
              {alertSettings.smsRecipients.map((recipient, i) => {
                return (
                  <div className='recipient-row' key={i}>
                    <div className='recipient-col' data-label="Name">{recipient.name}</div>
                    <div className='recipient-col' data-label="Type">{recipient.phone ? 'SMS' : 'Email'}</div>
                    <div className='recipient-col' data-label="Contact">{recipient.phone || recipient.email}</div>
                    <div className='recipient-col' data-label="Enabled?">
                      <AwnSwitch
                        checked={!recipient.disabled}
                        onChange={() => {
                          const settings = Object.assign({}, alertSettings)
                          settings.smsRecipients[i].disabled = !settings.smsRecipients[i].disabled
                          userActions.updateSetting('alerts', settings)
                        }}
                      />
                    </div>
                    <div className='recipient-col' data-label="Delete">
                      <small>
                        <a
                          className='glyphicon glyphicon-trash'
                          onClick={() => {
                            if (window.confirm(`Stop sending alerts to ${recipient.name}?`)) {
                              const settings = Object.assign({}, alertSettings)
                              settings.smsRecipients = settings.smsRecipients.filter((r, j) => j !== i)
                              userActions.updateSetting('alerts', settings)
                            }
                          }}
                        />
                      </small>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      }
      multiSms = (
        <div className='multi-sms block'>
          <h3>WBGT Guideline Alerts</h3>
          {smsBody}
          <h4>Alert Recipients</h4>
          {recipients}
        </div>
      )
    }
    let show = (
      <>
        {this._socialPrefs()}
        <div className='block'>
          <h3>Device Alerts<QuestionMark link="https://ambientweather.com/faqs/question/view/id/1793/" /></h3>
          {appAlertExplain && (
            <p className='warning'>
              App notifications are only available to users who have installed the Ambient Weather ios or android apps. <a href='https://ambientweather.com/sms-update' target='_blank' rel='noreferrer'>Learn more</a>.
            </p>
          )}
          <div className='prefs'>
            {radios}
            {freq}
          </div>
          <div className='message'>
            {messages}
          </div>
          {multiSms}
        </div>
        <div className='block'>
          <h3>Customizations</h3>
          <AlertCrud />
        </div>
      </>
    )
    if (tab === 'group') {
      show = <AlertSets />
    }
    if (tab === 'timeline') {
      show = (
        <div className='block clearfix'>
          <h3>Your alerts</h3>
          <p>Find all your alerts here{alertSetsAvail(user) ? ', including personal and team notifications.' : '.'}</p>
          <div className='legend'>
            <div>
              <i className='glyphicon glyphicon-user' />
              <span>Personal Alerts</span>
            </div>
            <div>
              <i className='glyphicon glyphicon-team-alerts' />
              <span>Team Alerts</span>
            </div>
          </div>
           <Instances />
        </div>
      )
    }
    return (
      <div className='alert-default-page'>
        <header className='main'>
          <h1>
            Alerts
          </h1>
        </header>
        <div className='tabs'>
          {Object.keys(ALERT_TABS).map(key => <Link key={key} to={`/alerts${key === 'alerts' ? '' : `/${key}`}`} className={classNames({
            active: tab === key
          }, 'tab', key)}>{ALERT_TABS[key]}</Link>)}
        </div>
        <div className='page-body'>
          {show}
        </div>
      </div>
    )
  }
}
export default bindAllActions(withRouter(DefaultPage))

DefaultPage.displayName = 'DefaultPage'
